import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
import showBac614 from './show'
/**
* @see \App\Http\Controllers\Public\UserController::show
* @see app/Http/Controllers/Public/UserController.php:21
* @route 'https://mktcode.digital/u/{user}'
*/
export const show = (args: { user: string | number | { username: string | number } } | [user: string | number | { username: string | number } ] | string | number | { username: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: 'https://mktcode.digital/u/{user}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Public\UserController::show
* @see app/Http/Controllers/Public/UserController.php:21
* @route 'https://mktcode.digital/u/{user}'
*/
show.url = (args: { user: string | number | { username: string | number } } | [user: string | number | { username: string | number } ] | string | number | { username: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { user: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'username' in args) {
        args = { user: args.username }
    }

    if (Array.isArray(args)) {
        args = {
            user: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        user: typeof args.user === 'object'
        ? args.user.username
        : args.user,
    }

    return show.definition.url
            .replace('{user}', parsedArgs.user.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Public\UserController::show
* @see app/Http/Controllers/Public/UserController.php:21
* @route 'https://mktcode.digital/u/{user}'
*/
show.get = (args: { user: string | number | { username: string | number } } | [user: string | number | { username: string | number } ] | string | number | { username: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\UserController::show
* @see app/Http/Controllers/Public/UserController.php:21
* @route 'https://mktcode.digital/u/{user}'
*/
show.head = (args: { user: string | number | { username: string | number } } | [user: string | number | { username: string | number } ] | string | number | { username: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Public\UserController::show
* @see app/Http/Controllers/Public/UserController.php:21
* @route 'https://mktcode.digital/u/{user}'
*/
const showForm = (args: { user: string | number | { username: string | number } } | [user: string | number | { username: string | number } ] | string | number | { username: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\UserController::show
* @see app/Http/Controllers/Public/UserController.php:21
* @route 'https://mktcode.digital/u/{user}'
*/
showForm.get = (args: { user: string | number | { username: string | number } } | [user: string | number | { username: string | number } ] | string | number | { username: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\UserController::show
* @see app/Http/Controllers/Public/UserController.php:21
* @route 'https://mktcode.digital/u/{user}'
*/
showForm.head = (args: { user: string | number | { username: string | number } } | [user: string | number | { username: string | number } ] | string | number | { username: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

const user = {
    show: Object.assign(show, showBac614),
}

export default user